import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { post } from '../services/api';
import Spinner from './Spinner';
import timeout from '../utils/timeout';

const MAX_ATTEMPTS = 2;
let attempts = 0;

interface KustomData {
  orderId: string;
  paypalOrderId: string;
}

interface ValidatePaymentProps {
  kustomData: KustomData;
  callback: Function;
}

function ValidateKustomPayment({ kustomData: { orderId, paypalOrderId }, callback }: ValidatePaymentProps) {
  const { t } = useTranslation();

  const [failedValidation, setFailedValidation] = useState(null);

  useEffect(() => {
    (async () => {
      if (orderId) {
        validatePayment();
      }
    })();
  }, [orderId]);

  const validatePayment = async () => {
    attempts += 1;

    if (attempts >= MAX_ATTEMPTS) {
      setFailedValidation(
        // eslint-disable-next-line max-len
        `${t('paymentValidationFailed')} ${orderId}`
      );
    }

    await timeout(1000 * attempts);

    const { response, error } = await post('/validate', { order_id: orderId, paypal_order_id: paypalOrderId }, true);
    if (error || !response || response.paymentStatus === 'CREATED') {
      validatePayment();
      return;
    }

    callback({
      kustom: response.html_snippet ? { htmlSnippet: response.html_snippet } : null,
      paypal: response.intent ? { ...response } : null
      // status: response.paymentStatus,
      // payment: response,
      // htmlSnippet: response.html_snippet
    });
  };

  const retryValidation = () => {
    attempts = 0;
    setFailedValidation(null);
    validatePayment();
  };

  return (
    <div className="stripe">
      {!failedValidation && (
        <div className="d-flex align-items-center m-3">
          <Spinner />
          <p className="mb-2 ml-2">{t('paymentVerification')}...</p>
        </div>
      )}
      <div className="m-3">
        {failedValidation && (
          <>
            <p className="golfamore-error">{failedValidation}</p>
            <div className="d-flex flex-row">
              <button type="button" className="button me-3" onClick={retryValidation}>
                {t('paymentVerify')}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ValidateKustomPayment;
